import { useFormController } from '@dreryk/react-common';
import { AutoLayout } from '@dreryk/react-components';

import {
   MedicalDocumentationCreateFormBean,
   MedicalDocumentationCreateFormController,
} from './MedicalDocumentationCreateForm.types';
import { getFormInitialValues } from './MedicalDocumentationCreateForm.utils';
import { PeriodRangeRadioGroup } from './PeriodRangeRadioGroup';
import { SelectedRangeDateSection } from './SelectedRangeDateSection';
import { ConfidentialDocumentationSection } from './ConfidentialDocumentationSection';

type MedicalDocumentationCreateFormRenderProps = Pick<
   MedicalDocumentationCreateFormController,
   'formState' | 'trigger' | 'handleSubmit'
>;

type MedicalDocumentationCreateFormProps = {
   readonly children: (renderProps: MedicalDocumentationCreateFormRenderProps) => JSX.Element;
};

export const MedicalDocumentationCreateForm = (props: MedicalDocumentationCreateFormProps): JSX.Element => {
   const { register, trigger, formState, watch, handleSubmit } = useFormController<MedicalDocumentationCreateFormBean>(
      getFormInitialValues()
   );

   const { periodRange } = watch(['periodRange']);

   return (
      <AutoLayout as={'form'} noValidate $direction={'vertical'} $horizontalResizing={'fill'} $spacing={18}>
         <PeriodRangeRadioGroup name={'periodRange'} register={register} />
         {periodRange === 'SELECTED_RANGE' && <SelectedRangeDateSection register={register} watch={watch} />}
         <ConfidentialDocumentationSection register={register} />

         {props.children({
            formState: formState,
            trigger: trigger,
            handleSubmit: handleSubmit,
         })}
      </AutoLayout>
   );
};
